import {CrudService} from '../services/';

export const postPeoples = (data) => {
    return CrudService._post({
        url: `peoples`,
        data
    });
};

export const getToken = (data) => {
    return CrudService._post({
        url: `v1/users/token`,
        data
    });
};

export const putUsers = (data) => {
    return CrudService._put({
        url: `v1/users/edit/${data.id}`,
        data
    });
};

export const getMe = () => {
    return CrudService._get({
        url: 'v1/users/me'
    });
};